import CustomButton from "../../../UIElements/CustomButton";
import { Box, Typography } from "@mui/material";

export default function SubmitDialogClient({
    onAcceptSubmitDossierToInstruction,
    hideModal,
}: {
    onAcceptSubmitDossierToInstruction: Function;
    hideModal: Function;
}) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2rem",
                flex: "1 0 0",
            }}
        >
            <Typography
                sx={{
                    alignSelf: "stretch",
                    color: "#005499",
                    textAlign: "center",
                    fontFamily: "Roboto",
                    fontSize: "1.50rem",
                    fontQtyle: "normal",
                    fontWeight: 700,
                    lineHeight: "normal",
                }}
            >
                En cliquant sur ce bouton pour soumettre mon dossier à l’instruction, je certifie que l’ensemble des éléments de preuve et documents justificatifs déposés sur la plateforme concernent et s’appliquent dans l’établissement candidat
            </Typography>
            <CustomButton
                onClick={async () => {
                    await onAcceptSubmitDossierToInstruction();
                }}
                label="Confirmer"
                customsx={{
                    width: "45%",
                }}
            />
            <CustomButton
                onClick={() => {
                    hideModal(false);
                }}
                label="Annuler"
                customsx={{
                    width: "45%",
                }}
            />
        </Box>
    );
}
